import ReactContainer from "../ReactContainer"
import HeaderLink from "./HeaderLink"
import Link from "../Link"
import React from "react"

import AccountTree from "@material-ui/icons/AccountTree"
import { withStyles } from "@material-ui/core/styles"

import useScrollTrigger from "@material-ui/core/useScrollTrigger"
import Slide from "@material-ui/core/Slide"

import AppBar from "@material-ui/core/AppBar"
import Hidden from "@material-ui/core/Hidden"
import IconButton from "@material-ui/core/IconButton"
import MenuIcon from "@material-ui/icons/Menu"

// side navigator
import Drawer from "@material-ui/core/Drawer"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemText from "@material-ui/core/ListItemText"

import navHeader from "../../../content/headerNav.yml"

import { colors } from "../../themeReact"

const styles = (theme) => ({
  headerMain: {
    backgroundColor: colors.darker,
    color: colors.white,
    position: "fixed",
    zIndex: theme.zIndex.drawer + 1,
    width: "100%",
    top: 0,
    left: 0,
  },
  headerContainerOne: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    height: 60,
    [theme.breakpoints.between("sm", "md")]: {
      height: 50,
    },
    [theme.breakpoints.down("xs")]: {
      height: 40,
    },
  },

  // for drawer styles
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
  drawerPaper: {
    width: 240,
    backgroundColor: colors.darker, //"rgb(35, 47, 62)",
    color: "white",
  },

  // for navbar logo and text
  headerLogoLink: {
    display: "flex",
    marginRight: 10,
    height: "100%",
    alignItems: "center",

    [theme.breakpoints.up("sm")]: {
      width: "calc(100% / 6)",
    },
    [theme.breakpoints.down("xs")]: {
      flex: "0 0 auto",
    },
    "&:hover": {
      textDecoration: "none",
    },
  },
  title: {
    font: "500 25px Roboto,sans-serif",
    cursor: "pointer",
    color: "white",
    textDecoration: "none",
    marginRight: 20,
    marginLeft: 5,
    "&:hover": {
      textDecoration: "none",
    },
    [theme.breakpoints.down("md")]: {
      fontSize: 16,
      fontWeight: 700,
      marginTop: 1,
    },
  },

  headerNavMain: {
    flex: "1",
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
    overflowX: "auto",
    overflowY: "hidden",
    height: "100%",
  },
  headerRightDiv: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "auto",
  },
  headerRightItemLink: {
    padding: "5px 10px",
    marginLeft: 10,
    whiteSpace: "nowrap",
    //fontSize: 14,
    color: colors.white,
    transition: "color 0.2s ease-out",

    "&:hover": {
      color: theme.palette.secondary.main,
      textDecoration: "none",
    },
  },

  svgL: {
    verticalAlign: -2,
    display: "inline-block",
    marginLeft: 5,
    color: colors.subtle,
  },
})

function HideOnScroll(props) {
  const { children } = props
  const trigger = useScrollTrigger({ target: undefined })

  return (
    <Slide appear={false} direction="down" in={!trigger}>
      {children}
    </Slide>
  )
}

const Header = ({ classes, location }) => {
  const [mobileOpen, setMobileOpen] = React.useState(false)

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  const drawer = (
    <div>
      <List>
        <ListItem button>
          <Link className={classes.headerLogoLink} to="/">
            <AccountTree
              className={classes.iconHover}
              color="secondary"
              style={{ fontSize: 30 }}
            />
            <span className={classes.title}>DB System</span>
          </Link>
        </ListItem>
        {navHeader.items.map((link) => (
          <ListItem button key={link.title} component={Link} to={link.to}>
            <ListItemText
              primary={link.title}
              //isActive={location.pathname.includes(link.activeSelector)}
            />
          </ListItem>
        ))}
      </List>
    </div>
  )

  return (
    <>
      <nav>
        <Hidden mdUp>
          <Drawer
            variant="temporary"
            anchor={"left"}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            classes={{
              paper: classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
      <HideOnScroll>
        <AppBar className={classes.headerMain}>
          <ReactContainer>
            <div className={classes.headerContainerOne}>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                edge="start"
                onClick={handleDrawerToggle}
                className={classes.menuButton}
              >
                <MenuIcon />
              </IconButton>

              <Link className={classes.headerLogoLink} to="/">
                <AccountTree
                  className={classes.iconHover}
                  color="secondary"
                  style={{ fontSize: 30 }}
                />
                <span className={classes.title}>DB System</span>
              </Link>

              <Hidden smDown>
                <nav className={classes.headerNavMain}>
                  {navHeader.items.map((link) => (
                    <HeaderLink
                      key={link.title}
                      isActive={location.pathname.includes(link.activeSelector)}
                      title={link.title}
                      to={link.to}
                    />
                  ))}
                </nav>
              </Hidden>

              {!location.pathname.includes("/") && (
                <div className={classes.headerRightDiv}>
                  <Link className={classes.headerRightItemLink} to="/">
                    DB System
                    <svg
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      width={15}
                      height={15}
                      className={classes.svgL}
                    >
                      <path
                        fill="currentColor"
                        d={`
                        M18.8,85.1h56l0,0c2.2,0,4-1.8,4-4v-32h-8v28h-48v-48h28v-8h-32l0,
                        0c-2.2,0-4,1.8-4,4v56C14.8,83.3,16.6,85.1,18.8,85.1z
                      `}
                      />
                      <polygon
                        fill="currentColor"
                        points={`
                        45.7,48.7 51.3,54.3 77.2,28.5 77.2,37.2 85.2,37.2 85.2,14.9 62.8,
                        14.9 62.8,22.9 71.5,22.9
                        `}
                      />
                    </svg>
                  </Link>
                </div>
              )}
            </div>
          </ReactContainer>
        </AppBar>
      </HideOnScroll>
    </>
  )
}

export default withStyles(styles)(Header)
